import moment, { type Moment } from 'moment';
import { API_DATE_FORMAT, UTC_DATE_TIME_FORMAT } from './apiDate';
const AGE_OF_MAJORITY = 18;
export const getRemainingDaysBetweenAPIDates = (from: APIDate, to: APIDate): number =>
  Math.ceil(moment(to, API_DATE_FORMAT).diff(moment(from, API_DATE_FORMAT), 'days', true));
export const getRemainingDays = (from: number, to: number): number =>
  Math.ceil(moment(to).diff(moment(from), 'days', true));
export const getRemainingDaysFromNow = (to: APIDate): number =>
  getRemainingDays(moment().valueOf(), moment(to, API_DATE_FORMAT).valueOf());
export const isAdult = (birthday: Timestamp, ageLimit: number = AGE_OF_MAJORITY) =>
  !moment(birthday).isAfter(moment().startOf('day').subtract(ageLimit, 'years'));

function formatDate(
  outputFormat: string,
): (arg0: string | null | undefined, arg1: string | null | undefined) => string | null | undefined {
  return (date: string | null | undefined, format: string | null | undefined) => {
    return date && format ? moment(date, format).format(outputFormat) : null;
  };
}

/**
 * Return an array of moment object for each days between
 * Opening and Closing dates (included).
 * @param  {string} opening The start date of range
 * @param  {string} closing The end date of range
 * @param  {string} format  The format of opening and closing date string
 * @return {array}          Array of moment objects
 */
function formatRangeDate(opening: string, closing: string, format: string): Array<Moment> {
  const start = moment(opening, format);
  const end = moment(closing, format);
  const dateRange = [];
  let current = start;

  if (
    typeof opening === 'undefined' ||
    typeof closing === 'undefined' ||
    !(start instanceof moment) ||
    !(end instanceof moment) ||
    !start.isValid() ||
    !end.isValid() ||
    start.isAfter(end)
  ) {
    return dateRange;
  }

  dateRange.push(current);

  while (!current.isSame(end)) {
    current = current.clone().add(1, 'day');
    dateRange.push(current);
  }

  return dateRange;
}

function formatTimestampDate(
  date: timestamp | null | undefined,
  format: string,
): string | null | undefined {
  const momentDate = moment(date);
  return date && momentDate.isValid() ? momentDate.format(format) : null;
}

function getTimestamp(date: string, format: string): number | null | undefined {
  const momentDate = moment(date, format);
  return date && momentDate.isValid() ? momentDate.valueOf() : null;
}

function momentFromUTCDateTime(utcDateTime: string): Moment {
  return moment(utcDateTime, UTC_DATE_TIME_FORMAT);
}

function isYearsRangeValid(
  departudeDate: string,
  format: string,
  add: moment$MomentDuration | {},
): boolean {
  return moment(departudeDate, format).isBetween([], moment().add(add));
}

export {
  formatDate,
  formatRangeDate,
  formatTimestampDate,
  getTimestamp,
  isYearsRangeValid,
  momentFromUTCDateTime,
};
